<template>
  <div
    :class="[{ 'boss-new': member.isNew },{ 'pega-input': isShowCheckbox }]"
    class="boss-resumecard-item-left"
    data-test="resumecard-avatar"
    @click="isShowCheckbox ? $emit('change', id) : ''"
  >
    <!-- ▼送信予約で使う？ -->
    <template v-if="isSmall">
      <div class="boss-resumecard-item-left-item boss-reserve">
        <div class="boss-layout boss-layout-vertical boss-layout-fill">
          <div>
            <div class="boss-layout boss-layout-start boss-layout-gap-small boss-avatar-small">
              <div>
                <img
                  v-if="isNew"
                  class="boss-avatar-image-small"
                  src="@/assets/images/boss-avatar-new.svg"
                  alt="24時間以内"
                >
                <img
                  v-else
                  class="boss-avatar-image-small boss-over-days"
                  src="@/assets/images/boss-avatar.svg"
                  alt="90日以上無し"
                >
              </div>
              <span
                class="boss-userid-text-small"
                data-test="small-user-id"
              >ID:{{ member.id }}</span>
            </div>
          </div>
          <div>
            <div class="boss-latest-action">
              <div
                v-tooltip="{ content: '現在の掲載期間中に送信したスカウトは濃色で表示、それ以前に送信していた場合は薄色で表示されます。'}"
                class="boss-resumecard-head"
              >
                最終ログイン
              </div>
              <div
                :class="{'boss-over-days': !isNew}"
                class="boss-resumecard-date"
                data-test="small-member_last_activity"
              >
                {{ lastActivityLabel | defaultIfBlank('最終ログイン') }}
              </div>
            </div>
            <div class="boss-another-scout">
              <div
                v-tooltip="{ content: '7日以内にこの会員をスカウトした他社企業数です。'}"
                class="boss-resumecard-head"
              >
                スカウト社数
              </div>
              <div
                class="boss-resumecard-date"
                data-test="small-approached-count"
              >
                {{ member.approachedCount | parseApproachedCount }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- ▲送信予約で使う？ -->
    <template v-else>
      <div class="text-center">
        <span
          style="display: inline-flex"
        >
          <input
            v-if="isShowCheckbox"
            :id="'is-selected-'+id"
            :checked="check"
            :value="id"
            type="checkbox"
            style="margin-top:2px"
            class="boss-userid pega-resumecard-check pega-input"
            data-test="is-selected"
          >
          <label
            class="boss-userid-text pega-resumecard-id pega-input"
            data-test="user-id"
          >ID:{{ member.id }}
          </label>
        </span>
      </div>
      <div class="boss-resumecard-item-left-item">
        <div class="boss-avatar">
          <template v-if="isScouted && !isMasking">
            <span
              :class="[isReadScout? 'boss-read':'boss-unread']"
              data-test="is-read-scout"
            />
          </template>
          <img
            v-if="isNew"
            class="boss-avatar-image"
            data-test="boss-avatar-new"
            src="@/assets/images/boss-avatar-new.svg"
            alt="24時間以内"
          >
          <img
            v-else
            class="boss-avatar-image"
            data-test="boss-avatar"
            src="@/assets/images/boss-avatar.svg"
            alt="90日以上無し"
          >
        </div>
        <div class="boss-latest-action">
          <div
            v-tooltip="{ content: '会員登録、ログイン、レジュメ更新、応募、いずれかを行った最新の時期です。'}"
            class="boss-resumecard-head"
          >
            最終ログイン
          </div>
          <div
            :class="{'boss-over-days': !isNew}"
            class="boss-resumecard-date"
            data-test="member_last_activity"
          >
            {{ lastActivityLabel | defaultIfBlank('最終ログイン') }}
          </div>
        </div>
        <div class="boss-another-scout">
          <div
            v-tooltip="{ content: '7日以内にこの会員をスカウトした他社企業数です。'}"
            class="boss-resumecard-head"
          >
            スカウト社数
          </div>
          <div
            class="boss-resumecard-date"
            data-test="approached-count"
          >
            {{ member.approachedCount | parseApproachedCount }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
.pega-resumecard-id {
  margin-bottom: 5px;
  position: initial;
}
.pega-resumecard-check {
  vertical-align: initial;
}
label > input {
  cursor: pointer;
}
</style>

<script>
import { now, createDate, dateDiff } from '@/lib/dateUtils.js'
import _ from 'lodash'

export default {
  filters: {
    defaultIfBlank (label, unregisteredValue, suffix = '') {
      return label ? label + suffix : unregisteredValue + '未登録'
    },
    parseApproachedCount (val) {
      return (!val) ? '0社' : (val < 50) ? `${val}社` : '50社以上'
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    member: {
      type: Object,
      required: true
    },
    checked: {
      type: Array,
      default: () => ([])
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isShowCheckbox: {
      type: Boolean,
      default: true
    },
    isScouted: {
      type: Boolean,
      default: false
    },
    isShowScoutDecline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scouts: ''
    }
  },
  computed: {
    check () {
      return _.includes(this.checked, this.id)
    },
    lastActivityLabel () {
      if (this.member.isEntry) return '応募済み'
      if (this.member.isScoutExcluded) return '除外済み'
      if (this.member.isWithdrawn) return '退会済み'
      if ((this.member.subscriptions && !this.member.subscriptions.scout) || this.member.isCkUser || this.member.isScoutRejection) return '利用停止'
      if (this.isShowScoutDecline) return '辞退'
      const lastActivityDatetime = this.lastActivityDatetime
      if (!lastActivityDatetime) return ''

      const DIFF_DAYS = this.dateDiff(lastActivityDatetime)
      const DIFF_HOURS = this.hourDiff(lastActivityDatetime)

      if (DIFF_HOURS <= 24) {
        return Math.ceil(DIFF_HOURS) + '時間以内'
      } else if (DIFF_DAYS === 1) {
        return '昨日'
      } else if (DIFF_DAYS <= 90) {
        return DIFF_DAYS + '日前'
      } else if (DIFF_DAYS >= 91) {
        return '90日以内無し'
      } else {
        return ''
      }
    },
    lastActivityDatetime () {
      return createDate(this.member.recentActionDate, 'YYYY-MM-DDTHH:mm:ss')
    },
    isReadScout () {
      return !!(_.get(this.member, 'scout.latestMessage.readDate'))
    },
    isNew () {
      return now().subtract(10, 'days').isSameOrBefore(this.lastActivityDatetime, 'day')
    },
    isMasking () {
      return (this.member.subscriptions && !this.member.subscriptions.scout) || this.member.isCkUser || this.member.isScoutRejection || this.member.isWithdrawn
    }
  },
  methods: {
    dateDiff (dateObject) {
      const date = createDate(dateObject)?.startOf('day')
      return dateDiff(now().startOf('day'), date, 'day')
    },
    hourDiff (dateObject) {
      const date = createDate(dateObject)
      return dateDiff(now(), date, 'hours', true)
    }
  }
}
</script>
